import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import UserControls from '@/components/UserControls.vue'
  import { vOnClickOutside } from '@vueuse/components'

  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useBreakpoint from '@/composables/useBreakpoint'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavBar',
  setup(__props) {

  const { logo, mcBurger } = useIcons()
  const { logoUrl, isInternalCompanyAdmin, hasValidUser, scrollToTop } = useCommonMixin()
  const { isDesktopDevice } = useBreakpoint()

  const timerId = ref(0)
  const openUserDropdown = ref(false)
  const navBarHeight = ref(0)
  const mainNavBarRef = ref<HTMLElement | null>(null)

  const hasMultipleCompanies = computed(() => {
    return UserModule.companies.length > 1
  })

  const toggleUserDropdown = () => {
    if (timerId.value) window.clearTimeout(timerId.value)
    timerId.value = window.setTimeout(() => {
      openUserDropdown.value = !openUserDropdown.value
    }, 50)
  }

  onMounted(() => {
    if (mainNavBarRef.value) {
      navBarHeight.value = mainNavBarRef.value.offsetHeight
    }
  })

return { __sfc: true,logo, mcBurger, logoUrl, isInternalCompanyAdmin, hasValidUser, scrollToTop, isDesktopDevice, timerId, openUserDropdown, navBarHeight, mainNavBarRef, hasMultipleCompanies, toggleUserDropdown, ref, computed, onMounted, SVGRenderer, UserControls, vOnClickOutside, useIcons, useCommonMixin, useBreakpoint, UserModule }
}

})